import React from 'react';

const Internships = () => {
  return (
    <section id="internships">
      <h1>Internships</h1>
      <ul className="academic-list">
        <li>
          <h3>SAP Developer Intern</h3>
          <span className="org">Ingenx Technology Private Limited</span>
          <div className="date">Jan 2026 – Jun 2026 | Gurgaon, India</div>
        </li>
        <li>
          <h3>Software Development Engineer Intern</h3>
          <span className="org">Web Tech Search Group</span>
          <div className="date">Apr 2025 – Aug 2025 | Remote</div>
        </li>
        <li>
          <h3>Full-Stack Web Developer Intern</h3>
          <span className="org">Techplement</span>
          <div className="date">Past Internship</div>
        </li>
      </ul>
    </section>
  );
};

export default Internships;
